export default __webpack_public_path__ + "static/media/filter_agenda_inactive.e4a8accf.svg";